// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-card {
    background: linear-gradient(to right, #061c61, #244aa3);
    color: white;
    border-radius: 8px;
}

.vehicle-img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid white;
}

.yellow-badge {
    background-color: #fcd44c;
    color: black;
    font-weight: 600;
    font-size: 0.8rem;
    padding: 4px 10px;
    border-radius: 4px;
    display: inline-block;
    margin-top: 4px;
}

.small-label {
    font-size: 0.9rem;
    color: #ffffffcc;
}

.date-text {
    font-size: 0.95rem;
    color: #fffacd;
}

.date-subtext {
    font-size: 0.8rem;
    color: #fcd44c;
}

.report-title {
    font-size: 1rem;
}

.report-green-color {
    background-color: #d1f2d3;
}

.report-yellow-color {
    background-color: #f0e9cc;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/MileageAnalysisTab_bus/VehicleReportCard.css"],"names":[],"mappings":"AAAA;IACI,uDAAuD;IACvD,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".report-card {\n    background: linear-gradient(to right, #061c61, #244aa3);\n    color: white;\n    border-radius: 8px;\n}\n\n.vehicle-img {\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid white;\n}\n\n.yellow-badge {\n    background-color: #fcd44c;\n    color: black;\n    font-weight: 600;\n    font-size: 0.8rem;\n    padding: 4px 10px;\n    border-radius: 4px;\n    display: inline-block;\n    margin-top: 4px;\n}\n\n.small-label {\n    font-size: 0.9rem;\n    color: #ffffffcc;\n}\n\n.date-text {\n    font-size: 0.95rem;\n    color: #fffacd;\n}\n\n.date-subtext {\n    font-size: 0.8rem;\n    color: #fcd44c;\n}\n\n.report-title {\n    font-size: 1rem;\n}\n\n.report-green-color {\n    background-color: #d1f2d3;\n}\n\n.report-yellow-color {\n    background-color: #f0e9cc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
